import React, { useState, useEffect, useCallback } from 'react';
import './AdminPage.css';
import { adminApi } from '../api/housekeeperApi';

const HK_TYPES = ['月嫂', '育婴师', '育儿师'];
const SCORE_TYPES = ['select', 'radio', 'manual', 'option'];
const SUBTYPES = ['', '护理型(小宝)', '早教型(大宝)'];

function Modal({ title, onClose, children }) {
  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal" onClick={e => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>{title}</h3>
          <button className="admin-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="admin-modal-body">{children}</div>
      </div>
    </div>
  );
}

/** 安全解析 applicable_types: 可能是 JSON 字符串、数组或 null */
function parseTypes(val) {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  try { return JSON.parse(val); } catch { return []; }
}

function Level1Form({ data, onSave, onCancel }) {
  const [form, setForm] = useState(() => {
    if (data) {
      return { ...data, applicable_types: parseTypes(data.applicable_types) };
    }
    return { name: '', code: '', max_score: 0, weight_percent: 0, applicable_types: ['月嫂', '育婴师', '育儿师'], sort_order: 0, description: '' };
  });
  const [saving, setSaving] = useState(false);
  const handleTypeToggle = (t) => {
    setForm(f => ({
      ...f,
      applicable_types: f.applicable_types.includes(t) ? f.applicable_types.filter(x => x !== t) : [...f.applicable_types, t]
    }));
  };
  const handleSave = async () => {
    if (!form.name.trim()) { alert('请输入类目名称'); return; }
    if (!form.code.trim()) { alert('请输入英文编码'); return; }
    if (!form.max_score || form.max_score <= 0) { alert('最高总分必须大于0'); return; }
    if (form.applicable_types.length === 0) { alert('请至少选择一种适用类型'); return; }
    setSaving(true);
    try { await onSave(form); } finally { setSaving(false); }
  };
  return (
    <div className="admin-form">
      <label>类目名称<input value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></label>
      <label>英文编码<input value={form.code} onChange={e => setForm({...form, code: e.target.value})} /></label>
      <label>最高总分<input type="number" step="0.5" value={form.max_score} onChange={e => setForm({...form, max_score: parseFloat(e.target.value) || 0})} /></label>
      <label>权重百分比<input type="number" value={form.weight_percent || 0} onChange={e => setForm({...form, weight_percent: parseFloat(e.target.value) || 0})} /></label>
      <label>适用类型<div className="admin-checkbox-group">{HK_TYPES.map(t => <label key={t} className="admin-checkbox"><input type="checkbox" checked={form.applicable_types.includes(t)} onChange={() => handleTypeToggle(t)} />{t}</label>)}</div></label>
      <label>排序序号<input type="number" value={form.sort_order} onChange={e => setForm({...form, sort_order: parseInt(e.target.value) || 0})} /></label>
      <label>说明<textarea value={form.description || ''} onChange={e => setForm({...form, description: e.target.value})} /></label>
      <div className="admin-form-actions"><button onClick={handleSave} disabled={saving}>{saving ? '保存中...' : '保存'}</button><button onClick={onCancel}>取消</button></div>
    </div>
  );
}

function Level2Form({ data, level1List, onSave, onCancel }) {
  const [form, setForm] = useState(() => {
    if (data) {
      return { ...data, applicable_types: parseTypes(data.applicable_types) };
    }
    return { level1_id: level1List.length > 0 ? level1List[0].id : '', name: '', code: '', max_score: 0, score_type: 'select', applicable_types: [], sort_order: 0, scoring_rule: '', select_options: '', option_score_map: '', bonus_config: '' };
  });
  const [saving, setSaving] = useState(false);
  const handleTypeToggle = (t) => {
    setForm(f => ({
      ...f,
      applicable_types: f.applicable_types.includes(t) ? f.applicable_types.filter(x => x !== t) : [...f.applicable_types, t]
    }));
  };
  const handleSave = async () => {
    if (!form.level1_id) { alert('请选择所属一级类目'); return; }
    if (!form.name.trim()) { alert('请输入分类名称'); return; }
    if (!form.code.trim()) { alert('请输入英文编码'); return; }
    if (!form.max_score || form.max_score <= 0) { alert('最高分必须大于0'); return; }
    if (form.applicable_types.length === 0) { alert('请至少选择一种适用类型'); return; }
    setSaving(true);
    try { await onSave(form); } finally { setSaving(false); }
  };
  return (
    <div className="admin-form">
      <label>所属一级类目<select value={form.level1_id} onChange={e => setForm({...form, level1_id: parseInt(e.target.value)})}>{level1List.map(l => <option key={l.id} value={l.id}>{l.name}({l.code})</option>)}</select></label>
      <label>分类名称<input value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></label>
      <label>英文编码<input value={form.code} onChange={e => setForm({...form, code: e.target.value})} /></label>
      <label>最高分<input type="number" step="0.5" value={form.max_score} onChange={e => setForm({...form, max_score: parseFloat(e.target.value) || 0})} /></label>
      <label>评分方式<select value={form.score_type} onChange={e => setForm({...form, score_type: e.target.value})}>{SCORE_TYPES.map(s => <option key={s} value={s}>{s}</option>)}</select></label>
      <label>适用类型<div className="admin-checkbox-group">{HK_TYPES.map(t => <label key={t} className="admin-checkbox"><input type="checkbox" checked={form.applicable_types.includes(t)} onChange={() => handleTypeToggle(t)} />{t}</label>)}</div></label>
      <label>排序序号<input type="number" value={form.sort_order} onChange={e => setForm({...form, sort_order: parseInt(e.target.value) || 0})} /></label>
      <label>评分规则<textarea value={form.scoring_rule || ''} onChange={e => setForm({...form, scoring_rule: e.target.value})} rows="3" /></label>
      {form.score_type === 'select' && <label>下拉选项JSON<textarea value={form.select_options || ''} onChange={e => setForm({...form, select_options: e.target.value})} rows="2" placeholder='["-","0","0.5","1","1.5","2"]' /></label>}
      {form.score_type === 'option' && <label>选项分数映射JSON<textarea value={form.option_score_map || ''} onChange={e => setForm({...form, option_score_map: e.target.value})} rows="3" placeholder='{"很好":4,"好":3,"一般":2,"差":1}' /></label>}
      {form.score_type === 'radio' && <label>选项JSON<textarea value={form.select_options || ''} onChange={e => setForm({...form, select_options: e.target.value})} rows="2" placeholder='["否(0分)","是(2分)"]' /></label>}
      <label>加分配置JSON<textarea value={form.bonus_config || ''} onChange={e => setForm({...form, bonus_config: e.target.value})} rows="2" /></label>
      <div className="admin-form-actions"><button onClick={handleSave} disabled={saving}>{saving ? '保存中...' : '保存'}</button><button onClick={onCancel}>取消</button></div>
    </div>
  );
}

function Level3Form({ data, level2List, onSave, onCancel }) {
  const [form, setForm] = useState(() => {
    if (data) {
      return { ...data, applicable_types: parseTypes(data.applicable_types) };
    }
    return { level2_id: level2List.length > 0 ? level2List[0].id : '', name: '', max_score: 0, score_type: 'select', select_options: '', option_score_map: '', applicable_types: [], applicable_subtype: '', sort_order: 0, scoring_criteria: '', ai_question_hint: '', need_ai_answer: 0 };
  });
  const [saving, setSaving] = useState(false);
  const handleTypeToggle = (t) => {
    setForm(f => ({
      ...f,
      applicable_types: f.applicable_types.includes(t) ? f.applicable_types.filter(x => x !== t) : [...f.applicable_types, t]
    }));
  };
  const handleSave = async () => {
    if (!form.level2_id) { alert('请选择所属二级分类'); return; }
    if (!form.name.trim()) { alert('请输入细项名称'); return; }
    if (!form.max_score || form.max_score <= 0) { alert('最高分必须大于0'); return; }
    if (form.applicable_types.length === 0) { alert('请至少选择一种适用类型'); return; }
    setSaving(true);
    try { await onSave(form); } finally { setSaving(false); }
  };
  return (
    <div className="admin-form">
      <label>所属二级分类<select value={form.level2_id} onChange={e => setForm({...form, level2_id: parseInt(e.target.value)})}>{level2List.map(l => <option key={l.id} value={l.id}>{l.name}({l.code})</option>)}</select></label>
      <label>细项名称<input value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></label>
      <label>最高分<input type="number" step="0.5" value={form.max_score} onChange={e => setForm({...form, max_score: parseFloat(e.target.value) || 0})} /></label>
      <label>评分方式<select value={form.score_type} onChange={e => setForm({...form, score_type: e.target.value})}>{SCORE_TYPES.filter(s => s !== 'option').map(s => <option key={s} value={s}>{s}</option>)}</select></label>
      <label>适用类型<div className="admin-checkbox-group">{HK_TYPES.map(t => <label key={t} className="admin-checkbox"><input type="checkbox" checked={form.applicable_types.includes(t)} onChange={() => handleTypeToggle(t)} />{t}</label>)}</div></label>
      <label>子类型(育儿师专用)<select value={form.applicable_subtype || ''} onChange={e => setForm({...form, applicable_subtype: e.target.value})}>{SUBTYPES.map(s => <option key={s} value={s}>{s || '不限(通用)'}</option>)}</select></label>
      <label>排序序号<input type="number" value={form.sort_order} onChange={e => setForm({...form, sort_order: parseInt(e.target.value) || 0})} /></label>
      {(form.score_type === 'select' || form.score_type === 'radio') && <label>选项JSON<textarea value={form.select_options || ''} onChange={e => setForm({...form, select_options: e.target.value})} rows="2" /></label>}
      <label>评分标准<textarea value={form.scoring_criteria || ''} onChange={e => setForm({...form, scoring_criteria: e.target.value})} rows="2" /></label>
      <label>AI问题提示<textarea value={form.ai_question_hint || ''} onChange={e => setForm({...form, ai_question_hint: e.target.value})} rows="2" /></label>
      <label>需要AI答案<select value={form.need_ai_answer} onChange={e => setForm({...form, need_ai_answer: parseInt(e.target.value)})}><option value={0}>否</option><option value={1}>是</option></select></label>
      <div className="admin-form-actions"><button onClick={handleSave} disabled={saving}>{saving ? '保存中...' : '保存'}</button><button onClick={onCancel}>取消</button></div>
    </div>
  );
}

function TreeView({ tree }) {
  const [expanded, setExpanded] = useState({});
  const toggle = (key) => setExpanded(e => ({...e, [key]: !e[key]}));
  if (!tree || tree.length === 0) return null;
  return (
    <div className="admin-tree">
      {tree.map(l1 => (
        <div key={`l1-${l1.id}`} className="admin-tree-node l1">
          <div className="admin-tree-label" onClick={() => toggle(`l1-${l1.id}`)}>
            <span className="admin-tree-arrow">{expanded[`l1-${l1.id}`] ? '▼' : '▶'}</span>
            <strong>{l1.name}</strong> ({l1.max_score}分{l1.weight_percent ? `, ${l1.weight_percent}%` : ''})
          </div>
          {expanded[`l1-${l1.id}`] && l1.children && l1.children.map(l2 => (
            <div key={`l2-${l2.id}`} className="admin-tree-node l2">
              <div className="admin-tree-label" onClick={() => toggle(`l2-${l2.id}`)}>
                <span className="admin-tree-arrow">{expanded[`l2-${l2.id}`] ? '▼' : '▶'}</span>
                {l2.name} ({l2.max_score}分, {l2.score_type})
                {l2.option_score_map && <span className="admin-tree-info"> 选项映射</span>}
              </div>
              {expanded[`l2-${l2.id}`] && l2.children && l2.children.map(l3 => (
                <div key={`l3-${l3.id}`} className="admin-tree-node l3">
                  <span>{l3.name}</span> ({l3.max_score}分, {l3.score_type})
                  {l3.applicable_subtype && <span className="admin-tree-subtype"> [{l3.applicable_subtype}]</span>}
                  {l3.need_ai_answer ? <span className="admin-tree-ai"> AI</span> : null}
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default function AdminPage() {
  const [activeTab, setActiveTab] = useState('level1');
  const [hkType, setHkType] = useState('育婴师');
  const [level1List, setLevel1List] = useState([]);
  const [level2List, setLevel2List] = useState([]);
  const [level3List, setLevel3List] = useState([]);
  const [tree, setTree] = useState([]);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchLevel1 = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await adminApi.getLevel1Categories(hkType);
      setLevel1List(res.data.data || []);
    } catch(e) {
      console.error('获取一级类目失败:', e);
      setError('获取一级类目失败: ' + (e.response?.data?.detail || e.message));
    }
    setLoading(false);
  }, [hkType]);

  const fetchLevel2 = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await adminApi.getLevel2Categories(hkType);
      setLevel2List(res.data.data || []);
    } catch(e) {
      console.error('获取二级分类失败:', e);
      setError('获取二级分类失败: ' + (e.response?.data?.detail || e.message));
    }
    setLoading(false);
  }, [hkType]);

  const fetchLevel3 = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await adminApi.getLevel3Categories(hkType);
      setLevel3List(res.data.data || []);
    } catch(e) {
      console.error('获取三级细项失败:', e);
      setError('获取三级细项失败: ' + (e.response?.data?.detail || e.message));
    }
    setLoading(false);
  }, [hkType]);

  const fetchTree = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await adminApi.getCategoryTree(hkType);
      setTree(res.data.data || []);
    } catch(e) {
      console.error('获取类目树失败:', e);
      setError('获取类目树失败: ' + (e.response?.data?.detail || e.message));
    }
    setLoading(false);
  }, [hkType]);

  useEffect(() => {
    if (activeTab === 'level1') fetchLevel1();
    else if (activeTab === 'level2') { fetchLevel1(); fetchLevel2(); }
    else if (activeTab === 'level3') { fetchLevel2(); fetchLevel3(); }
    else if (activeTab === 'tree') fetchTree();
  }, [activeTab, hkType, fetchLevel1, fetchLevel2, fetchLevel3, fetchTree]);

  const handleSaveLevel1 = async (form) => {
    if (modal.editData) {
      await adminApi.updateLevel1Category(modal.editData.id, form);
    } else {
      await adminApi.createLevel1Category(form);
    }
    setModal(null);
    await fetchLevel1();
  };

  const handleSaveLevel2 = async (form) => {
    if (modal.editData) {
      await adminApi.updateLevel2Category(modal.editData.id, form);
    } else {
      await adminApi.createLevel2Category(form);
    }
    setModal(null);
    await fetchLevel2();
  };

  const handleSaveLevel3 = async (form) => {
    if (modal.editData) {
      await adminApi.updateLevel3Category(modal.editData.id, form);
    } else {
      await adminApi.createLevel3Category(form);
    }
    setModal(null);
    await fetchLevel3();
  };

  const handleSaveWrapper = async (saveFn, form) => {
    try {
      await saveFn(form);
    } catch(e) {
      alert('保存失败: ' + (e.response?.data?.detail || e.message));
    }
  };

  const handleDelete = async (level, id) => {
    if (!window.confirm('确认删除？')) return;
    try {
      if (level === 'level1') await adminApi.deleteLevel1Category(id);
      else if (level === 'level2') await adminApi.deleteLevel2Category(id);
      else await adminApi.deleteLevel3Category(id);
      if (level === 'level1') await fetchLevel1();
      else if (level === 'level2') await fetchLevel2();
      else await fetchLevel3();
    } catch(e) { alert('删除失败: ' + (e.response?.data?.detail || e.message)); }
  };

  const handleInitTemplates = async () => {
    if (!window.confirm(`确认初始化${hkType}默认模板？已有同名模板将跳过。`)) return;
    setLoading(true);
    try {
      const res = await adminApi.initDefaultTemplates(hkType);
      alert(`初始化完成！\n一级类目: ${res.data.stats.level1_count}\n二级分类: ${res.data.stats.level2_count}\n三级细项: ${res.data.stats.level3_count}`);
      fetchLevel1();
    } catch(e) { alert('初始化失败: ' + (e.response?.data?.detail || e.message)); }
    setLoading(false);
  };

  /** 根据 level1_id 查找名称 */
  const getLevel1Name = (id) => {
    const item = level1List.find(l => l.id === id);
    return item ? item.name : id;
  };

  /** 根据 level2_id 查找名称 */
  const getLevel2Name = (id) => {
    const item = level2List.find(l => l.id === id);
    return item ? item.name : id;
  };

  const tabs = [
    { key: 'level1', label: '一级类目' },
    { key: 'level2', label: '二级分类' },
    { key: 'level3', label: '三级细项' },
    { key: 'tree', label: '树形总览' },
    { key: 'init', label: '一键初始化' },
  ];

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h2>测评类目管理后台</h2>
        <div className="admin-type-selector">
          <label>阿姨类型：</label>
          <select value={hkType} onChange={e => setHkType(e.target.value)}>
            {HK_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
      </div>

      <div className="admin-tabs">
        {tabs.map(tab => (
          <button key={tab.key} className={`admin-tab ${activeTab === tab.key ? 'active' : ''}`} onClick={() => setActiveTab(tab.key)}>
            {tab.label}
          </button>
        ))}
      </div>

      {loading && <div className="admin-loading">加载中...</div>}
      {error && <div className="admin-error">{error}</div>}

      {activeTab === 'level1' && (
        <div className="admin-section">
          <button className="admin-btn-add" onClick={() => setModal({type: 'level1', editData: null})}>新增一级类目</button>
          <table className="admin-table">
            <thead><tr><th>ID</th><th>名称</th><th>编码</th><th>满分</th><th>权重%</th><th>适用类型</th><th>排序</th><th>状态</th><th>操作</th></tr></thead>
            <tbody>
              {level1List.map(item => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.name}</td>
                  <td>{item.code}</td>
                  <td>{item.max_score}</td>
                  <td>{item.weight_percent}</td>
                  <td>{parseTypes(item.applicable_types).join(', ')}</td>
                  <td>{item.sort_order}</td>
                  <td>{item.is_active ? '启用' : '停用'}</td>
                  <td>
                    <button onClick={() => setModal({type: 'level1', editData: item})}>编辑</button>
                    <button onClick={() => handleDelete('level1', item.id)}>删除</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {level1List.length === 0 && !loading && <div className="admin-empty">暂无数据，可点击「一键初始化」创建默认模板</div>}
        </div>
      )}

      {activeTab === 'level2' && (
        <div className="admin-section">
          <button className="admin-btn-add" onClick={() => {
            if (level1List.length === 0) { alert('请先添加一级类目'); return; }
            setModal({type: 'level2', editData: null});
          }}>新增二级分类</button>
          <table className="admin-table">
            <thead><tr><th>ID</th><th>一级类目</th><th>名称</th><th>编码</th><th>满分</th><th>评分方式</th><th>适用类型</th><th>排序</th><th>操作</th></tr></thead>
            <tbody>
              {level2List.map(item => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{getLevel1Name(item.level1_id)}</td>
                  <td>{item.name}</td>
                  <td>{item.code}</td>
                  <td>{item.max_score}</td>
                  <td>{item.score_type}</td>
                  <td>{parseTypes(item.applicable_types).join(', ')}</td>
                  <td>{item.sort_order}</td>
                  <td>
                    <button onClick={() => setModal({type: 'level2', editData: item})}>编辑</button>
                    <button onClick={() => handleDelete('level2', item.id)}>删除</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {level2List.length === 0 && !loading && <div className="admin-empty">暂无数据</div>}
        </div>
      )}

      {activeTab === 'level3' && (
        <div className="admin-section">
          <button className="admin-btn-add" onClick={() => {
            if (level2List.length === 0) { alert('请先添加二级分类'); return; }
            setModal({type: 'level3', editData: null});
          }}>新增三级细项</button>
          <table className="admin-table">
            <thead><tr><th>ID</th><th>二级分类</th><th>名称</th><th>满分</th><th>评分方式</th><th>适用类型</th><th>子类型</th><th>排序</th><th>AI答案</th><th>操作</th></tr></thead>
            <tbody>
              {level3List.map(item => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{getLevel2Name(item.level2_id)}</td>
                  <td>{item.name}</td>
                  <td>{item.max_score}</td>
                  <td>{item.score_type}</td>
                  <td>{parseTypes(item.applicable_types).join(', ')}</td>
                  <td>{item.applicable_subtype || '-'}</td>
                  <td>{item.sort_order}</td>
                  <td>{item.need_ai_answer ? '是' : '否'}</td>
                  <td>
                    <button onClick={() => setModal({type: 'level3', editData: item})}>编辑</button>
                    <button onClick={() => handleDelete('level3', item.id)}>删除</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {level3List.length === 0 && !loading && <div className="admin-empty">暂无数据</div>}
        </div>
      )}

      {activeTab === 'tree' && (
        <div className="admin-section">
          <TreeView tree={tree} />
          {tree.length === 0 && !loading && <div className="admin-empty">暂无数据，可点击「一键初始化」创建默认模板</div>}
        </div>
      )}

      {activeTab === 'init' && (
        <div className="admin-section">
          <h3>一键初始化{hkType}默认模板</h3>
          <p>将根据测评表标准数据自动创建{hkType}的三级类目模板。已有同名模板将跳过。</p>
          <button className="admin-btn-init" onClick={handleInitTemplates} disabled={loading}>
            初始化{hkType}模板
          </button>
        </div>
      )}

      {modal && modal.type === 'level1' && (
        <Modal title={modal.editData ? '编辑一级类目' : '新增一级类目'} onClose={() => setModal(null)}>
          <Level1Form data={modal.editData} onSave={(form) => handleSaveWrapper(handleSaveLevel1, form)} onCancel={() => setModal(null)} />
        </Modal>
      )}

      {modal && modal.type === 'level2' && (
        <Modal title={modal.editData ? '编辑二级分类' : '新增二级分类'} onClose={() => setModal(null)}>
          <Level2Form data={modal.editData} level1List={level1List} onSave={(form) => handleSaveWrapper(handleSaveLevel2, form)} onCancel={() => setModal(null)} />
        </Modal>
      )}

      {modal && modal.type === 'level3' && (
        <Modal title={modal.editData ? '编辑三级细项' : '新增三级细项'} onClose={() => setModal(null)}>
          <Level3Form data={modal.editData} level2List={level2List} onSave={(form) => handleSaveWrapper(handleSaveLevel3, form)} onCancel={() => setModal(null)} />
        </Modal>
      )}
    </div>
  );
}
